import React from "react"
import { useState, useEffect } from "react"
// import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "../ui/card"
import {
    FileEdit,
    Sparkles,
} from "lucide-react"

import axios from "axios"
import { useCRUDController, Card, Button, AIGenerateButton, Row, Col, Select } from "./ot"
import { useNavigate } from "react-router-dom"


const BaseCanvasEdit0 = ({
    title = "編輯文案內容",
    description = "使用畫布編輯器拖放元件來創建您的文案",
    icon = true,
    className = "border-purple-200 dark:border-purple-800 bg-gradient-to-br from-purple-50 to-transparent dark:from-purple-950/30 dark:to-transparent",
    showSaveButton = true,
    showAIButton = true,
    showBindFormButton = false,
    showBindAdPlanButton = false,
    saveButtonName = "儲存文案",
    aiButtonName = "AI一鍵生成",
    aiButtonClassName = "bg-green-500 hover:bg-purple-600 text-white",
    showAIButtonIcon = true,
    styles = {},
    onSaveClick = () => { },
    aiGenerateQuantityRecommendationsAPIRoute = "/utility/ai_produce/controller/quantity_recommendations",
    children = null,

    target = "文案",
    propsSelectionOptions = [],
    propsSetSelectionOptions = () => { },
    propsComponentData = [],
    onComponentQuantityRecommendationsResultChange = () => { },
    toolBarRender = () => { return [] },
    bindFormColumnSourceDocumentId = null,  // 綁定表單的 document id
    onBindFormColumnSourceDocumentIdChange = () => { }, // 綁定表單的 document id 改變時的回調
    bindAdPlanSourceDocumentId = null,  // 綁定文案的 document id
    onBindAdPlanSourceDocumentIdChange = () => { }, // 綁定表單的 document id 改變時的回調
}) => {
    const navigate = useNavigate();
    const allDocumentController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
            },
            onBefore: () => { },
            apiRoute: "/utility/document/base_view?only_name=1",
        });
    const adPlanDocumentController = useCRUDController({ apiRoute: "/ad_plan_management/backend/content_document/base_view" })

    useEffect(() => {
        if ((!!showBindFormButton || !!showBindAdPlanButton) && allDocumentController.ResponseData.length === 0) {
            allDocumentController.getData({})
            adPlanDocumentController.getData({})
        }
    }, [showBindFormButton])


    return (
        <div className="space-y-6">
            <Card
                classNames={className}
                headerParallel={true}
                title={title}
                description={description}
                extra={<Row>
                    <Col span={24}>
                        <Row justify="between" gutter={4}>
                            <Col>
                                {showSaveButton &&
                                    <Button
                                        variant="outline"
                                        className="border-green-200 dark:border-green-800 hover:bg-green-50 dark:hover:bg-green-900/30"
                                        onClick={() => {
                                            onSaveClick(true)
                                        }}
                                    >
                                        {saveButtonName}
                                    </Button>}
                            </Col>
                            <Col>
                                {showAIButton &&
                                    <AIGenerateButton
                                        aiButtonName={aiButtonName}
                                        aiButtonClassName={aiButtonClassName}
                                        showAIButtonIcon={showAIButtonIcon}
                                        aiGenerateQuantityRecommendationsAPIRoute={aiGenerateQuantityRecommendationsAPIRoute}
                                        target={target}
                                        propsSelectionOptions={propsSelectionOptions}
                                        propsComponentData={propsComponentData}
                                        onComponentQuantityRecommendationsResultChange={(values) => {
                                            onComponentQuantityRecommendationsResultChange(values)
                                        }}
                                    />
                                    // <Button
                                    //     className={aiButtonClassName}
                                    //     onClick={() => {
                                    //         AiControllers.postData([
                                    //             {
                                    //                 target: target,
                                    //                 input: propsComponentData,
                                    //                 ...propsSelectionOptions
                                    //             }
                                    //         ])
                                    //     }}
                                    // >
                                    //     {showAIButtonIcon && <Sparkles className="w-4 h-4 mr-2" />}
                                    //     {aiButtonName}
                                    // </Button>
                                }
                            </Col>
                            <Col>
                                {showBindFormButton && <div className="flex flex-wrap items-center gap-2">
                                    <Select
                                        value={bindFormColumnSourceDocumentId}
                                        options={
                                            allDocumentController.ResponseData.map((doc) => {
                                                let name_language_data = doc?.name_language_data || []
                                                let name_language_data_zh_TW = name_language_data.find((n) => n.language_code === "zh-TW") || {}
                                                let title = name_language_data_zh_TW?.language_culture_value || doc?.title || "無標題"
                                                return {
                                                    label: title,
                                                    value: doc?.document_id
                                                }
                                            })
                                        }
                                        onChange={(value) => {
                                            onBindFormColumnSourceDocumentIdChange(value)
                                        }}
                                    />

                                </div>}

                            </Col>
                            <Button
                                onClick={() => {
                                    navigate(`/ad_plan/form_static/_1`)
                                }}
                                className="whitespace-nowrap" >查看表單及編輯
                            </Button>
                            <Col>
                                {showBindAdPlanButton && <div className="flex flex-wrap items-center gap-2">
                                    <Select
                                        value={bindAdPlanSourceDocumentId}
                                        options={
                                            adPlanDocumentController.ResponseData.map((doc) => {
                                                let name_language_data = doc?.name_language_data || []
                                                let name_language_data_zh_TW = name_language_data.find((n) => n.language_code === "zh-TW") || {}
                                                let title = name_language_data_zh_TW?.language_culture_value || doc?.title || "無標題"
                                                return {
                                                    label: title,
                                                    value: doc?.document_id
                                                }
                                            })
                                        }
                                        onChange={(value) => {
                                            onBindAdPlanSourceDocumentIdChange(value)
                                        }}
                                    />

                                </div>}

                            </Col>
                            {(toolBarRender()).map((ele) => {
                                return <Col>{ele}</Col>;
                            })}
                            <Col>
                            </Col>
                        </Row>


                    </Col>

                </Row>}
                icon={icon}
            >
                <Row>
                    <Col span={24}>
                        {children}
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export default BaseCanvasEdit0;
